import { PollAnswerProps } from './types';

export const PollAnswer = ({ children }: PollAnswerProps) => <div className="flex flex-col">{children}</div>;
